import styled from 'styled-components';

const ButtonLogout = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  background-color: transparent;
  border: 0;
  font-size: 28px;
  cursor: pointer;
  color: var(--on-background);
`;

export default ButtonLogout;
